'use client'

import * as React from 'react'

import { setSessionDraftOwner } from '@/lib/drafts/session-draft'
import { createClient } from '@/lib/supabase/client'

/**
 * Tells the composer drafts (lib/drafts/session-draft.ts) which account this
 * tab is signed in as, from the browser's Supabase session (review of
 * v1.164.0, P1-2). Every way a session ends without `performSignOut` lands
 * here with no session or another one, and the drafts of any other account
 * in the tab go:
 * - the session expired (SIGNED_OUT, or the next page opens with none);
 * - the middleware signed the person out (/login, /auth/signout);
 * - an invitation was accepted (app/join signs out, then /login);
 * - someone else signed in.
 * Reads the local session only (no request to Auth). Renders nothing.
 */
export function SessionDraftOwner() {
  React.useEffect(() => {
    let supabase: ReturnType<typeof createClient>
    try {
      supabase = createClient()
    } catch {
      return
    }
    // INITIAL_SESSION arrives first with the session the tab has (or none).
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSessionDraftOwner(session?.user?.id ?? null)
    })
    return () => subscription.unsubscribe()
  }, [])

  return null
}
